import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ClockAIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <Path d="M3.24 9H4.06286M14.76 9H9.00412V3.24402M9.00412 13.9412V14.764M3.48101 3.48101L4.06286 4.06286M13.947 13.9371L14.5288 14.519M14.5288 3.48101L13.947 4.06286M4.06286 13.9371L3.48101 14.519M0.771429 0.771429H17.2286V17.2286H0.771429V0.771429Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

ClockAIcon.displayName = 'ClockAIcon';
